import {Board, BoardRequest, DepartureBoardResponse, ArrivalBoardResponse} from "./model/api";
import {Common} from "./Common";
import {Logger} from "../util/Logger";

const sourceFileName = "DepartureBoardController.ts";

export class DepartureBoardController {

	/**
	 * Adds application level error handling (checks the response codes).
	 *
	 * @returns the departureboard for the given request.
	 */
	public static async getDepartureBoard(request: BoardRequest, token:string):
		Promise<Board> {

		if (request == null) {
			throw new Error(`BoardRequest is null`);
		}
		
		console.log(`Requesting DepartureBoard for the following extId: ${request.extId}`)
		Logger.debug(sourceFileName, `Requesting DepartureBoard for the following extId: ${request.extId}`);
		const departureBoardResponse = await DepartureBoardController._getBoard(request, token, "DepartureBoard");
		return departureBoardResponse.board;
	}

	/**
	 * Adds application level error handling (checks the response codes).
	 *
	 * @returns the arrivalboard for the given request.
	 */
	public static async getArrivalBoard(request: BoardRequest, token:string):
		Promise<Board> {

		if (request == null) {
			throw new Error(`BoardRequest is null`);
		}
		console.log(`Requesting ArrivalBoard for the following extId: ${request.extId}`)
		Logger.debug(sourceFileName, `Requesting ArrivalBoard for the following extId: ${request.extId}`);
		const arrivalBoardResponse = await DepartureBoardController._getBoard(request, token, "ArrivalBoard");
		return arrivalBoardResponse.board;
	}

	private static async _getBoard(request: BoardRequest, token: string, endpointName: string): Promise<DepartureBoardResponse | ArrivalBoardResponse> {
		Logger.debug(sourceFileName,
			`Requesting ${endpointName} for the following extId: ${request.extId}`);
	
		let requestHeaders: any = {
			"Content-Type": "application/json",
			"Accept": "application/json",
			"Authorization": "Bearer " + token,
		};
	
		const query = this.buildRequestQuery(request);
	
		const requestURL = this.buildRequestURL(endpointName, query);
		console.log(`Requesting ${endpointName} with url ${requestURL}`);
		Logger.debug(sourceFileName, `Requesting ${endpointName} with url ${requestURL}`);
		const resBody = await fetch(requestURL,
			{
				method: "GET",
				headers: requestHeaders,
			},
		);
	
		if (!resBody.ok) {
			throw new Error(`Error while sending GET request to ${endpointName} API endpoint.`
				+ ` HTTP status code was ${resBody.status}. HTTP body of request: ${JSON.stringify(request)}.`);
		}
	
		const resJSON = await resBody.json();
		const resObj = resJSON as DepartureBoardResponse | ArrivalBoardResponse;
	
		return resObj;
	}
	
	private static buildRequestQuery(request: BoardRequest): Record<string, string> {
		const query: Record<string, string> = {};
	
		for (const [key, value] of Object.entries(request)) {
			if (value !== undefined && value !== null && value !== "") {
				query[key] = String(value);
			}
		}
	
		return query;
	}
	
	private static buildRequestURL(endpointName: string, query: Record<string, string>): string {
		const filteredQuery = Object.entries(query)
			.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
			.join("&");
	
		return Common.getVAOActionUrl(endpointName + (filteredQuery ? "?" + filteredQuery : ""));
	}
}